// Vercel Speed Insights
import { injectSpeedInsights } from '@vercel/speed-insights';
injectSpeedInsights();

// Vercel Analytics
import { inject } from '@vercel/analytics';
inject();
